import { Component, inject, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { Subject } from 'rxjs';
import { BaseBulkType } from '../../common/abstract/BaseBulkType';

@Component({
  selector: 'app-bulk-date-type',
  templateUrl: './bulk-date-type.component.html',
  styleUrl: './bulk-date-type.component.scss'
})
export class BulkDateTypeComponent extends BaseBulkType implements OnInit{
  // hide: boolean = false;
  // hasSelectedData: boolean = false;
  primengConfig = inject(PrimeNGConfig);
  observer = new Subject();
  dateFormat = 'dd/mm/yy';
  date : any;
  showFormat: boolean = false;
  calendarView: string = 'date';
  dateValue: string = '';
  isChecked: boolean = false;
  style: any = {'height': '37.6px', 'width':'244.6px','margin-left':'5px', 'border':'var(--bs-border-width) solid var(--bs-border-color)'};

  onCheckboxChange(event: Event){
    const input = event.target as HTMLInputElement;
    this.isChecked = input.checked;
    if(!this.isChecked){
      this.formControl.setValue(undefined);
    }else{
      if(!this.formControl.value){
        this.isChecked = false;
        input.checked = false;
      }
    }
  }

  constructor() {
    super();
  }

  ngOnInit() {
    this.hide = this.props.hidden || this.hide;

    if(this.formControl.value){
      this.isChecked = true;
      this.date = this.formControl.value;
    }else{
      this.isChecked = false;
    }
    this.expandCheckbox();
  }

  onCalendarFocus(event: FocusEvent) {
    // Prevent the calendar from opening on focus
    event.stopPropagation();
  }

  onCalendarClick(calendar: any) {
    // Manually show the calendar overlay on click
    calendar.showOverlay();
  }


  onSelect(event:any){
    const date = new Date(event);
    date.setHours(12,0,0);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    const year = date.getFullYear();
    this.dateValue=`${day}/${month}/${year}`;
    this.formControl.setValue(this.dateValue); 
    this.isChecked = true;
    event.checked = true;
  }

  override conmuteHide(){
    this.hide = !this.hide;
  }

}
